/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ProfileSetItemStatus from './ProfileSetItemStatus';

/**
 * The ProfileSetItem model module.
 * @module model/ProfileSetItem
 * @version 1.0.0
 */
class ProfileSetItem {
    /**
     * Constructs a new <code>ProfileSetItem</code>.
     * a profilset item
     * @alias module:model/ProfileSetItem
     */
    constructor() { 
        
        ProfileSetItem.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ProfileSetItem</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProfileSetItem} obj Optional instance to populate.
     * @return {module:model/ProfileSetItem} The populated <code>ProfileSetItem</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProfileSetItem();

            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ProfileSetItemStatus.constructFromObject(data['status']);
            }
        }
        return obj;
    }


}

/**
 * @member {String} type
 */
ProfileSetItem.prototype['type'] = undefined;

/**
 * @member {module:model/ProfileSetItemStatus} status
 */
ProfileSetItem.prototype['status'] = undefined;






export default ProfileSetItem;

